/** Demo account fields for the profile page (seed identities use `{id}@peer-start.demo`). */
export function demoEmail(personaId: string): string {
  return `${personaId}@peer-start.demo`;
}

export function demoUuid(seed: string, namespace: string): string {
  const bytes = Array.from({ length: 16 }, (_, index) => {
    let hash = 0;
    const input = `${namespace}:${seed}:${index}`;
    for (let i = 0; i < input.length; i += 1) {
      hash = Math.imul(31, hash) + input.charCodeAt(i);
    }
    return Math.abs(hash) % 256;
  });
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = bytes.map((byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function formatProfileDate(date: Date, language: string): string {
  return new Intl.DateTimeFormat(language === "nl" ? "nl-NL" : "en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
}
